import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App";
import './localization/i18n'
render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);


// import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import App from "./components/App";
// import "./localization/i18n";

// const container = document.getElementById("root");
// const root = createRoot(container);

// root.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>
// );

